import { FailedPage } from '@/components/FailedPage';

import { useAuthentication } from '@/hooks/useAuthentication';

function ApplicationTypeSelectionFailedPage() {
  const { onBackToSignIn } = useAuthentication();

  return (
    <FailedPage
      translationPrefix="applicationSelectionFailed"
      onAction={onBackToSignIn}
      testIdPrefix="application-type-selection-failed-page"
    />
  );
}

export default ApplicationTypeSelectionFailedPage;
